<template>
  <JoinORPInvite
    :applicant-name="inviteData.publisherName"
    :applicant-type="'publisher'"
    :account-name="inviteData.accountName"
    :invite-status="inviteStatus"
    :is-whitelabel="isWhitelabel"
    :invite-data="inviteData"
  />
</template>

<script>

import JoinORPInvite from '@/modules/auth/components/JoinORPInvite';

export default {
  components: { JoinORPInvite },
  props: {
    isWhitelabel: {
      type: Boolean,
      default() {
        return true;
      },
    },
    inviteStatus: {
      type: Object,
      default() {
        return {};
      },
    },
    inviteData: {
      type: Object,
      default() {
        return {};
      },
    }
  },
};
</script>

<style>

</style>